module.exports = __webpack_public_path__ + "static/media/checkbox.45f05943.svg";